export class CustomParamsProcessorModel {
  ProcessorType: number;
}
